// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon___20To7","sizeBox":"sizeBox___3j7KF","size":"size___1qEJw"};